import { GqlFeatureType } from "~/__generated__";

export type FeatureGeometryType = "Point" | "Polygon" | "LineString";

type IdNamePair = { id: string; name: string };
export type ObservationType = { id: string; name: string; featureType: GqlFeatureType };

export type FeatureCreateOptionArea = {
    type: "area";
    geometryType: FeatureGeometryType;
    protocols?: IdNamePair[];
};

export type FeatureCreateOptionObservation = {
    type: "observation";
    researchType: IdNamePair;
    observationType: ObservationType;
    species: IdNamePair;
};

export type FeatureCreateOptionEcologicalFunction = {
    type: "ecologicalFunction";
    species: IdNamePair;
    researchType: IdNamePair;
    ecologicalFunctionType: { id: string; name: string; featureType: GqlFeatureType };
};

export type FeatureCreateOptionOther = {
    type: "other";
    geometryType: FeatureGeometryType;
};

export type FeatureCreateOptionNone = {
    type: "none";
};

export type FeatureCreateOption =
    | FeatureCreateOptionArea
    | FeatureCreateOptionObservation
    | FeatureCreateOptionOther
    | FeatureCreateOptionNone
    | FeatureCreateOptionEcologicalFunction;

export const FeatureCreateOption: {
    none: () => FeatureCreateOptionNone;
    other: (geometryType: FeatureGeometryType) => FeatureCreateOptionOther;
    area: (geometryType: FeatureGeometryType, protocols?: IdNamePair[]) => FeatureCreateOptionArea;
    observation: (
        species: IdNamePair,
        researchType: IdNamePair,
        observationType: ObservationType,
    ) => FeatureCreateOptionObservation;
    ecologicalFunction: (
        species: IdNamePair,
        researchType: IdNamePair,
        ecologicalFunctionType: { id: string; name: string; featureType: GqlFeatureType },
    ) => FeatureCreateOptionEcologicalFunction;
} = {
    none: () => ({ type: "none" }),
    other: geometryType => ({ type: "other", geometryType }),
    area: (geometryType, protocols = []) => ({
        type: "area",
        geometryType,
        protocols,
    }),
    observation: (species, researchType, observationType) => ({
        type: "observation",
        researchType,
        observationType,
        species,
    }),
    ecologicalFunction: (species, researchType, ecologicalFunctionType) => ({
        type: "ecologicalFunction",
        species,
        researchType,
        ecologicalFunctionType,
    }),
};
